import { atom, selector } from 'recoil';

import { NotificationResponse } from '../models/NotificationResponse';

export interface NotificationStateProps {
  items?: NotificationResponse[];
}
export const notificationState = atom<NotificationStateProps>({
  key: 'notificationState',
  default: {
    items: undefined,
  },
});

export const notificationStateUnreadItems = selector<{
  items: NotificationResponse[];
}>({
  key: 'notificationStateUnreadItems',
  get: ({ get }) => {
    const state = get(notificationState);
    return {
      items: state.items?.filter((item) => !item.readAt) || [],
    };
  },
});
